import React, { useEffect } from "react";
import { useOffers } from "../hooks/contexts/offers-hook";
import ErrorModal from "./Modals/ErrorModal";
import { CircularProgress } from "@material-ui/core";

/**
 * This function/component diplays the list of offers in a select. 
 * This uses the useOffers Provider to retrieve the offers data.
 * @returns {React.JSX.Element} 
 */
export default function Offers({ loan }) {
  const { offers, offer, setOffer, errorMessage, isLoading } = useOffers();

  const updateOffer = (selOffer) => {
    if (offer?.id !== selOffer?.id)
      setOffer(selOffer);
  };

  useEffect(() => console.log(offer), [offer]);

  useEffect(() => defaultOffer(), [, offers]);

  const defaultOffer = () => {
    if (!offers)
      return 
    if (offers.find((off) => off.id === loan.offerId))
      return updateOffer(offers.find((off) => off.id === loan.offerId))
    else
      updateOffer(offers[0]);
  }

  const mappedOffers = offers.map((offerX, i) => {
    return (
      <option
        key={i}
        selected={offer && offerX.id === offer.id}
        value={offerX.id}>
        {offerX.name}
      </option>
    );
  }
  );

  return errorMessage ?
    <ErrorModal
      errorMessage={errorMessage} />
    : (offers.length === 0 && isLoading) ?
      <CircularProgress size={50} color="inherit" />
      : (offers.length == 0 && !isLoading) ?
      <div>No Offers to Show</div>
      : (
        <>
          <div className="savingsText modal fin">TPO Offers</div>
          <select
            className="finInput prices"
            defaultValue={() => loan.offerId ? loan.offerId : offer ? offer.id : offers[0].id}
            onChange={(e) => {updateOffer(offers.find((offer) => offer.id === e.target.value))}}
          >
            {[...mappedOffers]}
          </select>
        </>
      );
};